export default "__VITE_ASSET__wL$Wz4E7__"